import { useMatches } from "react-router-dom";

import type { AppRouteHandle } from "@/features/shared/navigation/route-handles";

export function useIsAdminRoute(): boolean {
  return useMatches().some(
    (match) => (match.handle as AppRouteHandle | undefined)?.appContext === "admin",
  );
}
